<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ch4"> </p>
<p class="CT"><span href="#/xhtml/contents#c_ch4" title="Link target outside of Sample"><span class="ePub-B">ALBUQUERQUE</span></span></p>
<p class="CO">Slouching back on the sofa of his basement studio apartment, Hamilton Cree sipped on an energy drink as he watched a rerun of last year’s World Cup finals on his wall screen.</p>
<p class="TX">It had been a long, frustrating day. First the traffic detail up north of Taos, then a raid on a drug house in Española, and finally the long drive home to Albuquerque.</p>
<p class="TX">The drug raid had been a farce: a half-dozen pimply kids cooking up some recreational junk in the kitchen of one of the new prefabs that had been set up for the flood refugees. City kids, from back east, snotty and yelling about their constitutional rights. Thought they’d masked all the surveillance sensors in their miserable little government-furnished house.</p>
<p class="TX">The robots burst into their hangout and tranked them while Cree and the other live officers waited outside and watched on the remote cameras. Drones circling overhead, the whole nine yards, just to bust some teenagers who had nothing better to do.</p>
<p class="TX">His phone buzzed. Almost glad of the interruption, Cree saw on the ID screen that it was his brother, from Nashville. He told the phone to put the call on the wall screen. He’d thought about getting a 3-D viewer, but decided to save the money and stick with the flat screen.</p>
<p class="TX">Brother Jefferson was eleven years older than Hamilton, but he still looked like a kid: he could afford rejuve treatments.</p>
<p class="TX">“What’s happening, Hambone?” asked Jeff, with his vid-star smile.</p>
<p class="TX">Hamilton hated his childhood nickname. Wearily he replied, “Same old shit.”</p>
<p class="TX">Jeff was the oldest of the family’s four boys and he had a real job as a bank supervisor in Nashville. Plus a wife and two kids of his own, a girl and a boy.</p>
<p class="TX">“Got a promotion,” Jeff said brightly.</p>
<p class="TX">“Yeah?”</p>
<p class="TX">“Yeah. I’m gonna be manager of our branch office in Hendersonville.”</p>
<p class="TX">“Good for you, Jeff.”</p>
<p class="TX">For the next half hour Hamilton listened with a growing mixture of envy and resentment as Jeff bragged about his latest step toward a happy retirement.</p>
<p class="TX">At last Jeff asked, “So what about you? Still guarding the highways of New Mexico?”</p>
<p class="TX">“Not for much longer,” Hamilton said, feeling the way he had when the school year was nearing its end.</p>
<p class="TX">“Anything interesting?” Jeff prodded.</p>
<p class="TX">So Hamilton told him about the star traveler. “Held up traffic for more’n half an hour, just so he and his alien gal could see the gorge.”</p>
<p class="TX">Jeff seemed impressed. “He’s been to another star. He’s met aliens.”</p>
<p class="TX">“She looks pretty human.”</p>
<p class="TX">“They claim the New Earth people are just as human as we are,” Jeff said. “But I don’t see how. They’re aliens. Aliens aren’t human.”</p>
<p class="TX">“I guess.”</p>
<p class="TX">“You know, Hank’s working in Chicago now, for the firm that sells those energy screens.”</p>
<p class="TX">“He is?”</p>
<p class="TX">“Yep. He’s going to send me one to put in my car. Like an airbag, only it’s stronger and protects the whole insides of the car, even if it’s totaled.”</p>
<p class="TX">“The energy screens are alien technology.”</p>
<p class="TX">“That’s right. One of the star travelers opened his own company to sell ’em. He’s rich!”</p>
<p class="TX">“From alien technology,” Hamilton muttered.</p>
<p class="TX">The brothers chatted for a few minutes more, then Jefferson said, “Gotta go now. Dinner bell’s ringing.”</p>
<p class="TX">“Okay. Say hello to Gina for me.”</p>
<p class="TX">“Sure. Whyn’t you come over here sometime and see us? The kids’d love to see their Uncle Hambone.”</p>
<p class="TX">Hamilton forced a grin. “Sure. Soon’s I get the chance. Got a three-day weekend coming up; maybe then.”</p>
<p class="TX">“Good. See ya then.”</p>
<p class="TX">“Yeah.”</p>
<p class="TX">Hamilton cut the connection and the wall screen went back to the World Cup. He leaned back on the sofa once more, thinking, Those damned star travelers. They get rich, they get to block traffic, they make us feel like little insects.</p>
<p class="TX">But he didn’t really feel like an insect. He felt like a man, a man who had somehow been left behind. A man who was filled with a growing, simmering resentment.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?17ce35da